import React, { FC, useEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";

import { useState } from "react";
import { HistoriesOrderingsModal } from "./HistoriesOrderingsModal";
import HistoriesOrderingsSearch from "./HistoriesOrderingsSearch";
import HistoriesOrderingsTable from "./HistoriesOrderingsTable";

const App = ({
  dispatch_info,
  dispatch_danger,
  dispatch_get_histories_orderings,
  dispatch_put_markets_exchanges_id_cancel,
}) => {
  const ref = useRef();
  const [t, i18n] = useTranslation();
  const maps = useSelector((state) => state.reduce_get_maps);
  useEffect(() => {
    // document.body.classList.toggle("login-page");
    // document.body.classList.add("color-default");
    // document.body.classList.toggle("color-default");
    // return function cleanup() {
    //   // document.body.classList.toggle("login-page");
    //   document.body.classList.toggle("color-default");
    // };
  }, []);

  const [searchHistoriesOrderings, set_searchHistoriesOrderings] = useState({
    _search: { page: 1, limit: 10 },
  });

  const [modalHistoriesOrderings, set_modalHistoriesOrderings] = useState(
    false
  );

  const histories_orderings = useSelector(
    (state) => state.reduce_get_histories_orderings
  );


 


  const inLoading =
    histories_orderings.isLoading || !histories_orderings.orders;
  const data_tables = inLoading ? [] : histories_orderings.orders;

  const total_count = inLoading ? 0 : histories_orderings.count;



  return (
    <>
      {/* <div className="content"> */}
        {/* <div className="info info-horizontal ml-4">
          <div className="description">
            <h4 className="info-title">
              <img
                className="mr-3"
                alt="..."
                src={require("assets/svg/bank-check.svg")}
                width="30px"
              />
              {t("出金承認")}
            </h4>
            <p className="mb-1 ml-5">{t("出金承認を管理します")}</p>
          </div>
        </div> */}
        <HistoriesOrderingsSearch
          inLoading={inLoading}
          searchHistoriesOrderings={searchHistoriesOrderings}
          set_searchHistoriesOrderings={set_searchHistoriesOrderings}
          dispatch_get={dispatch_get_histories_orderings}
          total_count={total_count}
        />
        <HistoriesOrderingsTable
          searchHistoriesOrderings={searchHistoriesOrderings}
          set_searchHistoriesOrderings={set_searchHistoriesOrderings}
          set_modalHistoriesOrderings={set_modalHistoriesOrderings}
          dispatch_put_markets_exchanges_id_cancel={
            dispatch_put_markets_exchanges_id_cancel
          }
          data_tables={data_tables}
          inLoading={inLoading}
        />
        <HistoriesOrderingsModal
          inLoading={inLoading}
          modal={modalHistoriesOrderings}
          close_modal={() => {
            // set_searchHistoriesOrderings({ limit: 10, page: 1 });
            set_modalHistoriesOrderings(false);
          }}
          searchHistoriesOrderings={searchHistoriesOrderings}
          set_searchHistoriesOrderings={set_searchHistoriesOrderings}
          searchHistoriesOrderings={searchHistoriesOrderings}
          // set_searchHistoriesOrderings={set_searchHistoriesOrderings}
          dispatch_info={dispatch_info}
          dispatch_danger={dispatch_danger}
          dispatch_put_markets_exchanges_id_cancel={
            dispatch_put_markets_exchanges_id_cancel
          }
        />
      {/* </div> */}
    </>
  );
};

export default App;
